export default __webpack_public_path__ + "static/gatsby_github_get_pat3-ce022aa1065c20b0bb9275452ea99d67.png";